import { ComputedRef } from 'vue'

import { JudgeDetail } from '@/domain/entities/judge/judgeDetail'
import { FreeSpaceJudgeDetailViewModel } from '@/presentation/viewmodels/freeSpace/freeSpaceJudgeDetailViewModel'

export class FreeSpaceJudgeDetailPresenter {
  private viewModel: FreeSpaceJudgeDetailViewModel

  constructor(viewModel: FreeSpaceJudgeDetailViewModel) {
    this.viewModel = viewModel
  }

  get judgeDetail(): ComputedRef<JudgeDetail> {
    return this.viewModel.judgeDetail
  }
}
